import $axios from "../axios";

function getAllHomeBannerImageListApi({params, callback}) {
  return $axios.get('/api/common/getAllHomeBannerImageList')
    .then(res => {
      callback(res.data);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getAllHomeBannerImageListApi
}



// WEBPACK FOOTER //
// ./src/api/common/commonApi.js